import { EditorView, basicSetup } from 'codemirror';
import { html } from '@codemirror/lang-html';
import { json} from '@codemirror/lang-json';
import { oneDark } from '@codemirror/theme-one-dark';
import { indentSelection } from '@codemirror/commands'

const codeMirrors = document.querySelectorAll('[data-codemirror]');
const defaultOptions = {
	language: 'html'
};


codeMirrors.forEach(codeMirror => {
  let options = JSON.parse(codeMirror.dataset.codemirror);
  let fullOptions = { ...defaultOptions, ...options };

  let view;
  switch (fullOptions.language) {
	case 'html':
	  view = new EditorView({
		doc: codeMirror.value,
		extensions: [basicSetup, html(), oneDark],
	  });
	  break;
	case 'json':
	  view = new EditorView({
		doc: codeMirror.value,
		extensions: [basicSetup, json(), oneDark],
	  });
	  break;
	default:
	  view = new EditorView({
		doc: codeMirror.value,
		extensions: [basicSetup, oneDark],
	  });
	  break;
  }

  

  // AUTOINDENT ON LOAD
  view.dispatch({
	selection: {
	  anchor: 0,
	  head: view.state.doc.length
	}
  });
  setTimeout(() => {
	indentSelection({
	  state: view.state,
	  dispatch: transaction => {
		view.update([transaction]);
		view.dispatch({
		  selection: {
			anchor: 0,
			head: 0
		  }
		});
	  }
	})
  }, 1000);

  codeMirror.parentNode.insertBefore(view.dom, codeMirror);
  codeMirror.style.display = 'none'
  if (codeMirror.form) {
	codeMirror.form.addEventListener('submit', () => {
	  codeMirror.value = view.state.doc.toString()
	});
  }
});